import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchDealCharges = async (params = {}) => {
  try {
    let qs = reqTransform.fetchDealCharges(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/CommonUtilities/FetchPlatformCharges?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchDealCharges(resData);
  } catch (err) {
    console.log('err---->', err);
    const errors = await utils.processApiErrors(err, '', 'fetchDealCharges');
    throw errors;
  }
};
